module.exports = __webpack_public_path__ + "static/media/edamame.b2e9a01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/edamame.jpg
// module id = 127
// module chunks = 0